import { useContext } from "react";
import { ExperimentsContext, UserExperiments } from "../ExperimentsProvider";

export const useExperiments = (): UserExperiments => {
  const ctx = useContext(ExperimentsContext);
  if (!ctx) throw new Error(`must be used within a ExperimentsProvider`);
  return ctx;
};
